import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { UserService } from '../services/user/user.service';
import { NotificationService } from '../services/notification.service';
import { ToastType } from '../enums/toast.enum';

export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const userService = inject(UserService);
  const notificationService = inject(NotificationService);

  const requiredPermissions: string[] = route.data['permissions'] || [];
  const userPermissions = userService.permissions;

  const hasPermission = requiredPermissions.every(p => userPermissions.includes(p));

  if (!hasPermission) {
    //Todo: poprawić powiadomienia o braku uprawnień
    notificationService.showMessage(ToastType.ERROR, 'Brak uprawnień', 'Nie masz wystarczających uprawnień, aby uzyskać dostęp do tej strony.');
  }

  return hasPermission;
};